var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.675 1.23047L28.5078 15.4662L32.0523 7.06731L47.675 1.23047Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42773 1.23047L22.4408 15.6011L19.0697 7.06731L3.42773 1.23047Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7787 34.2288L35.6738 42.0497L46.5962 45.0549L49.7362 34.4021L40.7787 34.2288Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4043 34.4021L4.52499 45.0549L15.4474 42.0497L10.3426 34.2288L1.4043 34.4021Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8307 21.0142L11.7871 25.6182L22.6325 26.0997L22.2472 14.4453L14.8307 21.0142Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2691 21.014L28.7563 14.3103L28.5059 26.0996L39.332 25.618L36.2691 21.014Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4473 42.0498L21.9583 38.8713L16.3334 34.4792L15.4473 42.0498Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1445 38.8713L35.6749 42.0498L34.7695 34.4792L29.1445 38.8713Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6749 42.0498L29.1445 38.8713L29.6646 43.1286L29.6069 44.9201L35.6749 42.0498Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4473 42.0498L21.5153 44.9201L21.4767 43.1286L21.9583 38.8713L15.4473 42.0498Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.61 31.6668L16.1777 30.0679L20.0112 28.3149L21.61 31.6668Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4922 31.6668L31.0911 28.3149L34.9438 30.0679L29.4922 31.6668Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4466 42.05L16.3713 34.229L10.3418 34.4024L15.4466 42.05Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.748 34.229L35.6727 42.05L40.7775 34.4024L34.748 34.229Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3339 25.6182L28.5078 26.0998L29.5095 31.6669L31.1084 28.3151L34.9611 30.068L39.3339 25.6182Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1792 30.068L20.0319 28.3151L21.6115 31.6669L22.6325 26.0998L11.7871 25.6182L16.1792 30.068Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7871 25.6182L16.3333 34.4794L16.1792 30.068L11.7871 25.6182Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9622 30.068L34.7695 34.4794L39.335 25.6182L34.9622 30.068Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6323 26.0996L21.6113 31.6668L22.8827 38.2356L23.1717 29.5863L22.6323 26.0996Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5084 26.0996L27.9883 29.567L28.2194 38.2356L29.5101 31.6668L28.5084 26.0996Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5094 31.6667L28.2188 38.2356L29.1434 38.8713L34.7683 34.4792L34.961 30.0679L29.5094 31.6667Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1777 30.0679L16.3318 34.4792L21.9568 38.8713L22.8814 38.2356L21.61 31.6667L16.1777 30.0679Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6079 44.9201L29.6657 43.1286L29.1841 42.7048H21.9218L21.4787 43.1286L21.5172 44.9201L15.4492 42.0498L17.5682 43.7835L21.864 46.7694H29.2419L33.5569 43.7835L35.6759 42.0498L29.6079 44.9201Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1434 38.8713L28.2188 38.2356H22.8828L21.9582 38.8713L21.4766 43.1285L21.9196 42.7047H29.182L29.6636 43.1285L29.1434 38.8713Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4831 16.3909L50.1205 8.53134L47.6741 1.23047L29.1426 14.9846L36.2701 21.0141L46.3449 23.9614L48.5795 21.3608L47.6163 20.6674L49.1574 19.2611L47.963 18.3365L49.5041 17.1614L48.4831 16.3909Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.53134L2.6374 16.3909L1.59717 17.1614L3.13825 18.3365L1.96318 19.2611L3.50426 20.6674L2.54108 21.3608L4.75639 23.9614L14.8312 21.0141L21.9587 14.9846L3.4272 1.23047L1 8.53134Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3469 23.9615L36.2721 21.0142L39.335 25.6181L34.7695 34.4794L40.7797 34.4023H49.7373L46.3469 23.9615Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8329 21.0142L4.7581 23.9615L1.40625 34.4023H10.3445L16.3355 34.4794L11.7893 25.6181L14.8329 21.0142Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5075 26.0997L29.1432 14.9847L32.0712 7.06738H19.0684L21.9579 14.9847L22.6321 26.0997L22.8633 29.6057L22.8825 38.2358H28.2185L28.2571 29.6057L28.5075 26.0997Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/fox.6560c97d.svg";
export { ForwardRef as ReactComponent };